import Icon from "@Atom/Icon";
import AutocompleteV2 from "@Atom/AutocompleteV2";
import Styles from "./styles.module.scss";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
// import POSTER from "@Assets/Images/870-smd-nita-31 okt.png";
// import POSTER_SECOND from "@Assets/Images/poster-example.png";
// import POSTER_THIRD from "@Assets/Images/BENEFIT_IMAGE_1.png";
// import JobSeekerList from "@Molecule/JobSeekerList";
import Pagination from "@Atom/PaginationJobSeeker";
import HomeFooter from "@Organism/Home/Business/HomeFooter";
import { getListJobSeeker } from "@Services/client/jobSeeker";
import { useDebounce } from "@Hooks/useDebounce";
import { useLocation, useNavigate } from "react-router-dom";
import NonLinearSlider from "@Atom/RangePriceSlider";
import Checkbox from "@Atom/Checkbox";
import JobSeekersCard from "@Molecule/JobSeekersCard";
import Images from "@Theme/Images";
import { capitalizedFirstLetter } from "@Helpers/capitalizedFirstLetter";
import {
  createCandidateBookmark,
  deleteCandidateBookmark,
} from "@Services/home";
import moment from "moment";
import ModalWrapper from "@Atom/ModalWrapper";
import JobPostingLinkModal from "@Molecule/_modal/JobPostingLinkModal";
import useWindowSize from "@Hooks/useWindowSize";
import EmptyData from "@Organism/Recruiter/PipelineDetail/EmptyData";
import Toast from "@Atom/Toast";
import { Button } from "@mui/material";
// import { isMobile } from "react-device-detect";
import { fileBaseUrl } from "@Config/api";
// import BACKGROUND_HEADER from "@Assets/Images/background-job-seaker.png";

export default function JobSeakerDetail({ initialData }) {
  const location = useLocation();
  const searchTerm = location?.state || "";
  const navigate = useNavigate();
  const [minValue, setMinValue] = useState(100000);
  const [maxValue, setMaxValue] = useState(25000000);
  const templatePrice = `${minValue.toLocaleString(
    "id"
  )} - ${maxValue.toLocaleString("id")}`;
  const { width } = useWindowSize();
  const [isLoadingBookmark, setIsLoadingBookmark] = useState(false);

  const [selectedItems, setSelectedItems] = useState([]);
  const isMobile = width <= 1200;

  // const [selectedItemsExperiences, setSelectedItemsExperiences] = useState([]);

  // const { pathname } = useLocation();

  const targetElement = useRef();
  const scrollingTop = () => {
    const elmnt = targetElement;
    elmnt.current.scrollIntoView({
      behavior: "auto",
      block: "center",
      inline: "start",
    });
  };
  useEffect(() => {
    scrollingTop();
  }, []);

  const filterOptions = () => {
    return [
      {
        title: "Kategori Pekerjaan Untukmu",
        value: "category",
        options: ["Semua", ...dataList?.categories],
      },
      {
        title: "Tipe Pekerjaan",
        value: "type",
        options: [
          "Semua",
          "Penuh Waktu",
          "Kontrak",
          "Magang",
          "Paruh Waktu",
          "Pekerja Lepas/Freelance",
          "Harian",
        ],
      },
      {
        title: "Level Pengalaman",
        value: "level",
        options: [
          "Semua",
          "Fresh Graduate",
          // "> 1 tahun",
          // "> 2 tahun",
          // "> 3 tahun",
          // "> 4 tahun",
          "1-3 tahun",
          "4-5 tahun",
          "5+ tahun",
        ],
      },
      {
        title: "Pendidikan",
        value: "education",
        options: [
          "Semua",
          "Sarjana Strata 3",
          "Sarjana Strata 2",
          "Sarjana Strata 1",
          "Diploma (D3)",
          "SMA Sederajat",
          "SMP Sederajat",
        ],
      },
      {
        title: "Jenis Tempat Kerja",
        value: "workAt",
        options: ["Semua", "Work From Office", "Work From Anywhere", "Hybrid"],
      },
    ];
  };

  // pagination
  const [valuePage, setValuePage] = useState(18);
  const [pages, setPages] = useState(1);
  const [pageList, setPageList] = useState(1);
  const [selectedPage, setSelectedPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState(searchTerm?.valueTitle || "");

  const [dataList, setDataList] = useState(initialData || null);

  const [isLoadingData, setIsLoadingData] = useState(false);

  const [valueSearchTermPlace, setValueSearchTermPlace] = useState("");

  const [isFocusInputSearch, setIsFocusInputSearch] = useState(false);

  const [activeFilters, setActiveFilters] = useState({
    category: ["Semua"],
    type: ["Semua"],
    level: ["Semua"],
    education: ["Semua"],
    workAt: ["Semua"],
  });

  useEffect(() => {
    setActiveFilters({
      category: ["Semua"],
      type: ["Semua"],
      level: ["Semua"],
      education: ["Semua"],
      workAt: ["Semua"],
    });
  }, []);

  const [isOpenFilterMobile, setIsOpenFilterMobile] = useState(false);

  function handleSearch() {
    navigate(`/job-seeker`, {
      state: {
        valueTitle: searchQuery,
        valuePlacement: valueSearchTermPlace,
      },
    });
  }

  useEffect(() => {
    if (
      searchTerm?.valueTitle ||
      searchTerm?.valuePlacement ||
      searchTerm?.valueTypeContract?.length > 0 ||
      searchTerm?.valueExperiences?.length > 0 ||
      searchTerm?.minValue ||
      searchTerm?.maxValue
    ) {
      setActiveFilters((prev) => ({
        ...prev,
        level: searchTerm?.valueExperiences,
      }));
      setSelectedItems(searchTerm?.valueTypeContract || []);
      setMinValue(searchTerm?.minValue || 100000);
      setMaxValue(searchTerm?.maxValue || 25000000);
      setValueSearchTermPlace(searchTerm?.valuePlacement || "");
      setSearchQuery(searchTerm?.valueTitle || "");
    }
  }, [
    searchTerm?.maxValue,
    searchTerm?.minValue,
    searchTerm?.valueExperiences,
    searchTerm?.valuePlacement,
    searchTerm?.valueTitle,
    searchTerm?.valueTypeContract,
  ]);

  const handleResetPlace = () => {
    setValueSearchTermPlace("");
    navigate(`/job-seeker`, {
      state: { valueTitle: searchQuery },
    });
  };

  const debouncedPlacement = useDebounce(
    searchTerm?.valuePlacement || searchTerm?.valueSearchTermPlace || "",
    300
  );
  const debouncedTypeContract = useDebounce(
    selectedItems || searchTerm?.valueTypeContract || "",
    300
  );

  const debouncedminPrice = useDebounce(
    minValue || searchTerm?.minValue || "",
    300
  );
  const debouncedmaxPrice = useDebounce(
    maxValue || searchTerm?.maxValue || "",
    300
  );

  const debounceSearchQuery = useDebounce(searchTerm?.valueTitle, 500);

  useEffect(() => {
    setSelectedPage(1);
  }, [debounceSearchQuery]);

  const backToTop = (top = 0) => {
    return window.scrollTo({
      behavior: "smooth",
      top: top,
    });
  };

  useEffect(() => {
    backToTop();
  }, [pages]);

  const refetchData = useCallback(
    async (isLoadingRefetch = true) => {
      const workAtMap = {
        "Work From Office": "WFO",
        "Work From Anywhere": "WFA",
        Hybrid: "Hybrid",
        Remote: "Remote",
      };

      const workAtValue =
        activeFilters.workAt[0] === "Semua"
          ? ""
          : activeFilters.workAt.map((item) => workAtMap[item]) || "";

      const workSystem = {
        Semua: "All",
        "Penuh Waktu": "Full Time",
        Kontrak: "Contract",
        Magang: "Internship",
        "Paruh Waktu": "Part Time",
        "Pekerja Lepas/Freelance": "Freelance",
        Harian: "Daily",
      };

      const workSystemValue =
        activeFilters.type[0] === "Semua"
          ? ""
          : activeFilters.type.map((item) => workSystem[item]) || "";

      const education = {
        "Sarjana Strata 3": "S3",
        "Sarjana Strata 2": "S2",
        "Sarjana Strata 1": "S1",
        "Diploma (D3)": "D3",
        "SMA Sederajat": "SMA",
        "SMP Sederajat": "SMP",
      };

      const educationValue =
        activeFilters.education[0] === "Semua"
          ? ""
          : activeFilters.education.map((item) => education[item]) || "";

      try {
        setIsLoadingData(isLoadingRefetch);
        const { response } = await getListJobSeeker(
          +valuePage,
          +selectedPage,
          debouncedPlacement,
          debounceSearchQuery || "",
          debouncedTypeContract,
          activeFilters?.level?.length > 0
            ? activeFilters?.level[0] === "Semua"
              ? ""
              : activeFilters.level
            : "",
          debouncedminPrice,
          debouncedmaxPrice,
          activeFilters?.category?.length > 0
            ? activeFilters?.category[0] === "Semua"
              ? ""
              : activeFilters?.category
            : "",
          workSystemValue,
          workAtValue,
          educationValue
        );

        setDataList(response);
        setIsLoadingData(false);
      } catch (err) {
        setIsLoadingData(false);
        console.log(err);
      }
    },
    [
      valuePage,
      selectedPage,
      debouncedPlacement,
      debounceSearchQuery,
      debouncedTypeContract,
      debouncedminPrice,
      debouncedmaxPrice,
      activeFilters.category,
      activeFilters.type,
      activeFilters.level,
      activeFilters.workAt,
      activeFilters.education,
    ]
  );

  useEffect(() => {
    refetchData();
  }, [refetchData]);

  const handleResetFilter = () => {
    setSelectedItems([]);
    setMinValue(100000);
    setMaxValue(25000000);
    setActiveFilters({
      category: ["Semua"],
      type: ["Semua"],
      level: ["Semua"],
      education: ["Semua"],
      workAt: ["Semua"],
    });
  };

  // START
  const [openDropdownAccordionFilter, setOpenDropdownAccordionFilter] =
    useState(filterOptions().map((defaultValue) => defaultValue.title));
  const handleAcordionFilter = (type) => {
    if (openDropdownAccordionFilter.includes(type)) {
      setOpenDropdownAccordionFilter((prev) =>
        prev.filter((existing) => existing !== type)
      );
    } else setOpenDropdownAccordionFilter((prev) => [...prev, type]);
  };

  const data = useMemo(() => {
    return dataList?.data?.map((l) => ({
      id: l?._id,
      name: capitalizedFirstLetter(l?.title),
      experience: l?.experience,
      workType: l?.workType,
      contractType: l?.contractType,
      workMethod: l?.workMethod,
      client: l?.clientName,
      location: l?.placement,
      salary: l?.salary,
      createdAt: moment(l?.createdAt).startOf("day").fromNow(),
      status: l?.status,
      isRevision: "",
      img: l?.iconUri ? fileBaseUrl + l?.iconUri : Images.PERAMATA_LOGO_CICRLE,
      isShowButton: "",
      isApply: l?.isApply,
      isArchived: l?.isBookmarked,
      _id: l?._id, // require for the <JobPostingLinkModal /> component
    }));
  }, [dataList?.data]);

  const [pendingFilters, setPendingFilters] = useState(activeFilters);

  const handleChangeFilter = (name, value) => {
    const temp = { ...activeFilters };

    if (temp[name].length >= 1 && value === "Semua") {
      temp[name] = ["Semua"];
    }

    if (temp[name].includes("Semua")) {
      temp[name] = temp[name].filter((c) => c !== "Semua");
    }

    if (temp[name].includes(value)) {
      // UNCHECK
      temp[name] = temp[name].filter((el) => el !== value);

      if (value === "1-3 tahun") {
        temp[name] = temp[name].filter(
          (el) => el !== "> 1 tahun" && el !== "> 2 tahun"
        );
      }

      if (value === "4-5 tahun") {
        temp[name] = temp[name].filter(
          (el) => el !== "> 3 tahun" && el !== "> 4 tahun"
        );
      }

      if (temp[name].length === 0) {
        temp[name].push("Semua");
      }
    } else {
      // CHECKED
      if (value === "1-3 tahun") {
        temp[name] = Array.from(
          new Set([...temp[name], value, "> 1 tahun", "> 2 tahun"])
        );
      }

      if (value === "4-5 tahun") {
        temp[name] = Array.from(
          new Set([...temp[name], value, "> 3 tahun", "> 4 tahun"])
        );
      }

      temp[name] = Array.from(new Set([...temp[name], value]));
    }

    backToTop();
    setActiveFilters(temp);
  };

  const handleChangeFilterMobile = (name, value) => {
    const temp = { ...pendingFilters };

    if (temp[name].length >= 1 && value === "Semua") {
      temp[name] = ["Semua"];
    }

    if (temp[name].includes("Semua")) {
      temp[name] = temp[name].filter((c) => c !== "Semua");
    }

    if (temp[name].includes(value)) {
      // UNCHECK
      temp[name] = temp[name].filter((el) => el !== value);

      if (value === "1-3 tahun") {
        temp[name] = temp[name].filter(
          (el) => el !== "> 1 tahun" && el !== "> 2 tahun"
        );
      }

      if (value === "4-5 tahun") {
        temp[name] = temp[name].filter(
          (el) => el !== "> 3 tahun" && el !== "> 4 tahun"
        );
      }

      if (temp[name].length === 0) {
        temp[name].push("Semua");
      }
    } else {
      // CHECKED
      if (value === "1-3 tahun") {
        temp[name] = Array.from(
          new Set([...temp[name], value, "> 1 tahun", "> 2 tahun"])
        );
      } else if (value === "4-5 tahun") {
        temp[name] = Array.from(
          new Set([...temp[name], value, "> 3 tahun", "> 4 tahun"])
        );
      } else {
        temp[name] = Array.from(new Set([...temp[name], value]));
      }
    }
    setPendingFilters(temp);
  };

  const handleSaveFilterMobile = () => {
    setIsOpenFilterMobile(false);
    setActiveFilters(pendingFilters);
  };

  const createArchiveJob = async (jobPostID) => {
    setIsLoadingBookmark(jobPostID);
    try {
      await createCandidateBookmark(jobPostID);
      refetchData(false);
    } catch (error) {
      console.log("Error create bookmark candidate", error);
    } finally {
      setIsLoadingBookmark(false);
    }
  };

  const deleteBookmark = async (jobPostID) => {
    setIsLoadingBookmark(jobPostID);
    try {
      await deleteCandidateBookmark(jobPostID);
      refetchData(false);
    } catch (error) {
      console.log("Error delete bookmark candidate", error);
    } finally {
      setIsLoadingBookmark(false);
    }
  };

  const [isLoadingCopyLink, setIsLodingCopyLink] = useState(null);
  const [error, setError] = useState(null);
  const [showModalLink, setShowModalLink] = useState("");

  const handleForm = (el) => {
    navigate(`/job-seeker/${el?._id}`);
  };

  useEffect(() => {
    setTimeout(() => {
      if (error) setError(false);
    }, 2000);
  }, [error]);

  const FilterToRender = ({ className }) => {
    return (
      <>
        {filterOptions().map((t) => (
          <div className={`${Styles.filterType} ${className} `} key={t.title}>
            <div className={Styles.title}>
              <span>{t.title}</span>
              <Icon
                icon={"arrow-left-rounded-primary"}
                color={"#09121F"}
                size={"18"}
                className={`${Styles.icon} ${
                  openDropdownAccordionFilter.some(
                    (prev) => prev === t.title
                  ) && Styles.active
                } `}
                onClick={() => handleAcordionFilter(t.title)}
              />
            </div>
            {openDropdownAccordionFilter.some((prev) => prev === t.title) && (
              <div className={Styles.list}>
                {t.options?.map((el, idxOption) => {
                  return (
                    <div className={Styles.check} key={idxOption}>
                      <Checkbox
                        type="job-post"
                        isChecked={
                          isMobile
                            ? pendingFilters[t.value]?.includes(el)
                            : activeFilters[t.value]?.includes(el)
                        }
                        setIsChecked={() =>
                          isMobile
                            ? handleChangeFilterMobile(t.value, el)
                            : handleChangeFilter(t.value, el)
                        }
                      />
                      <span>
                        {t.value === "category" && idxOption === 0
                          ? `🔥 Semua Pekerjaan`
                          : el}
                      </span>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        ))}
        <div className={Styles.filterType}>
          <span>Range Gaji</span>
          <div className={Styles.rangePrice}>Rp{templatePrice}</div>
          <div className={Styles.slider}>
            <NonLinearSlider
              setMax={setMaxValue}
              setMin={setMinValue}
              min={minValue}
              max={maxValue}
              type="filter-jobs"
            />
          </div>
        </div>
      </>
    );
  };

  // END

  return (
    <div className={Styles.bodyJobSeaker}>
      <div className={Styles.autoScroll} ref={targetElement} />
      <div className={Styles.filterInput}>
        <h2>Daftar Semua Loker</h2>
        <div className={Styles.fileringArea}>
          <div className={Styles.filterStart}>
            <label>Pekerjaan</label>
            <div
              className={`${Styles.searchBox} ${
                isFocusInputSearch && Styles.active
              } `}
            >
              <Icon icon={"search"} size={20} color={"#9E9E9E"} />
              <input
                onBlur={() => setIsFocusInputSearch(false)}
                onFocus={() => setIsFocusInputSearch(true)}
                placeholder={"Cari nama pekerjaan ataupun perusahaan"}
                onChange={(e) => setSearchQuery(e.target.value)}
                value={searchQuery}
              />
            </div>
          </div>

          <div className={Styles.filterStart}>
            <label>Lokasi</label>
            <div className={` ${Styles.viewRow} `}>
              <div className={Styles.search}>
                <AutocompleteV2
                  type={"job-seeker-detail"}
                  placeholder={"Semua lokasi"}
                  options={dataList?.cities || []}
                  value={valueSearchTermPlace}
                  setValue={setValueSearchTermPlace}
                  isLoading={isLoadingData}
                  onReset={handleResetPlace}
                  iconName="location"
                />
              </div>
              <div className={Styles.buttonSave} onClick={handleSearch}>
                <span className={Styles.searchText}>Cari Pekerjaan</span>
                <Icon icon={"search"} size={20} color={"#FFFFFF"} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={Styles.contentJobSeaker}>
        <div className={Styles.topContent}></div>
        <div className={Styles.bottomContent}>
          {width > 1200 && (
            <div className={Styles.filterSection}>
              <div className={Styles.iconFilter}>
                <div className={Styles.boxIcon}>
                  <Icon icon={"adjustment"} size={20} color={"#1571DE"} />
                  <span className={Styles.filterSpan}>Filter</span>
                </div>
                <div className={Styles.reset} onClick={handleResetFilter}>
                  Reset
                </div>
              </div>

              <div className={Styles.renderedFilterBox}>
                <FilterToRender />
              </div>
            </div>
          )}
          <div className={Styles.cardSection}>
            <Toast
              isSent={error}
              label={"Job Posting Not Found"}
              bg="red"
              icon="cross-circle"
            />

            <div className={`${Styles.wrapperCards}`}>
              {data?.map((el, idx) => {
                return (
                  <JobSeekersCard
                    key={idx}
                    data={el}
                    setShowDetail={() => handleForm(el)}
                    loading={isLoadingCopyLink === el.id || isLoadingData}
                    isLoadingBookmarkedIcon={isLoadingBookmark === el?.id}
                    onClickArchiveIcon={() => {
                      if (!localStorage?.getItem("accessTokenUserLanding")) {
                        navigate("/user/login");
                      } else {
                        el?.isArchived
                          ? deleteBookmark(el?.id)
                          : createArchiveJob(el?.id);
                      }
                    }}
                  />
                );
              })}
            </div>
            {data?.length === 0 && !isLoadingData && !searchQuery && (
              <div className={Styles.wrapEmptyHandler}>
                <EmptyData />
              </div>
            )}
            {data?.length === 0 && !isLoadingData && searchQuery && (
              <div className={Styles.wrapEmptyHandler}>
                <EmptyData customLabel={"Loker yang anda cari tidak ada"} />
              </div>
            )}

            {showModalLink && (
              <ModalWrapper
                show={showModalLink}
                handleClose={() => setShowModalLink(null)}
                isLandingPage
              >
                <JobPostingLinkModal
                  data={showModalLink}
                  handleClose={() => setShowModalLink(null)}
                />
              </ModalWrapper>
            )}

            <div>
              <Pagination
                totalPage={dataList?.totalPage}
                value={valuePage}
                totalData={dataList?.totalData}
                setValue={setValuePage}
                pages={pages}
                setPages={setPages}
                pageList={pageList}
                setPageList={setPageList}
                selectedPage={selectedPage}
                setSelectedPage={setSelectedPage}
              />
            </div>
          </div>
        </div>
      </div>
      <div className={Styles.filterResponsive}>
        {width <= 1200 && (
          <div
            className={Styles.bodyFilter}
            onClick={() => setIsOpenFilterMobile(true)}
          >
            <Icon icon={"adjustment"} size={20} color={"#404040"} />
            <span className={Styles.filterSpan}>Filter</span>
          </div>
        )}
      </div>
      {width <= 1200 && isOpenFilterMobile && (
        <div className={`${Styles.wrapperModalFilterMobile} `}>
          <div className={Styles.header}>
            <h4>Filter</h4>
            <div
              className={Styles.closeBtn}
              onClick={() => setIsOpenFilterMobile(false)}
            >
              <Icon icon={"cross"} size={"24px"} className={Styles.closeIcon} />
            </div>
          </div>

          <div className={Styles.mainContentFilterMobile}>
            <FilterToRender className={Styles.mobileFiltering} />

            <div
              className={Styles.btnSave}
              onClick={() => handleSaveFilterMobile()}
            >
              <Button className={Styles.button} variant="contained">
                Simpan
              </Button>
            </div>
          </div>
        </div>
      )}
      <HomeFooter />
    </div>
  );
}
